// src/index.tsx
// react-speech-recognition ships a pre-compiled build that calls the global
// regeneratorRuntime directly (regeneratorRuntime.mark/.wrap) — must be loaded
// before anything else that might import it.
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom/client';

// Import Ant Design reset CSS first (base styles)
import 'antd/dist/reset.css';

// Import our custom CSS with Tailwind (this will override Ant Design where needed)
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { installHttpClient } from './lib/http/install';
import { clearSession } from './utils/auth/sessionUtilities';

// Before the first render, so the session probe already goes through the shared client.
installHttpClient({ onSessionEnded: clearSession });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// Performance monitoring
reportWebVitals();